import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { FaEye } from "react-icons/fa6";
import { PiDevicesLight } from "react-icons/pi";
import { authServices } from "../../../APIServices/UserData/authServices";
import QRCode from "react-qr-code";
import { AiOutlineGlobal } from "react-icons/ai";
import { IoLogoAndroid, IoLogoApple } from "react-icons/io";

const SetupAnotherDevice = ({ auth, isDark }) => {
  const [hidden, setHidden] = useState(true);
  const [loginQRCode, setLoginQRCode] = useState("")
  const generateQRForMobileLogin = async () => {
    let data = await authServices.generateQRForMobileLogin(auth)
    setLoginQRCode(data?.qrToken || "")
  }

  useEffect(() => {
    generateQRForMobileLogin()
    const interval = setInterval(() => {
      generateQRForMobileLogin();
    }, 1 * 60 * 1000);
    return () => clearInterval(interval);
  }, [auth]);
  return (
    <>
      <div className="w-75 m-auto pb-1 pt-3">
        <h5 className="fw-bold mb-1">Setup Another Device</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-75 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <Container fluid>
                <Row>
                  <Form.Group as={Col} md={4}>
                    <div className="hstack justify-content-center h-100">
                      <PiDevicesLight style={{ fontSize: 120 }} className="text-muted" />
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={8}>
                    <Form.Label className="small mb-1">Step One</Form.Label>
                    <h6 className="mb-3">Download Pixa Vault for your desktop and mobile devices</h6>
                    <div className="hstack gap-2 small mb-2">
                      <IoLogoApple className="text-muted" /> <a style={{ textDecoration: "none" }} href="#"><span>Pixa Vault for iOS.</span></a>
                      <span className="text-muted">Requires iOS 17.5 or later.</span>
                    </div>
                    <div className="hstack gap-2 small mb-2">
                      <IoLogoAndroid className="text-muted" /> <a style={{ textDecoration: "none" }} href="#"><span>Pixa Vault for Android.</span></a>
                      <span className="text-muted">Requires Android 9 or later.</span>
                    </div>
                    <div className="hstack gap-2 small mb-2">
                      <AiOutlineGlobal /> <a style={{ textDecoration: "none" }} href="#"><span>Pixa Vault for Web Brawser.</span></a>
                    </div>
                  </Form.Group>
                </Row>
                <hr />
                <Row>
                  <Form.Group as={Col} md={4} className="my-2">
                    <div className="border p-2 rounded-1 position-relative">
                      <div className={`position-absolute text-muted ${isDark ? "bg-dark" : "bg-white"} px-2`} style={{ fontSize: 10, top: -8, left: "50%", transform: "translateX(-50%)" }}>
                        SETUP CODE
                      </div>
                      <div className="position-relative" style={{ userSelect: "none" }}>
                        {hidden ? (
                          <QRCode className="p-3" style={{ filter: "blur(5px) brightness(0.6)", userSelect: "none", pointerEvents: "none", transition: "filter 0.3s ease" }} value={loginQRCode} size={180} />
                        ) : (
                          <QRCode className="p-3" value={loginQRCode} size={180} />
                        )}
                        {hidden && (
                          <div className="position-absolute top-50 start-50 text-white" style={{ transform: "translate(-50%, -50%)" }}>
                            <FaEye style={{ fontSize: 25 }} />
                          </div>
                        )}
                      </div>
                      <div
                        className={`position-absolute ${isDark ? "bg-dark" : "bg-white"}`}
                        style={{ bottom: -13, left: "50%", transform: "translateX(-50%)" }}
                      >
                        <Button variant="outline-primary" className="rounded-1 py-1 px-3" style={{ fontSize: 10 }} onClick={() => setHidden(!hidden)}>
                          {hidden ? "SHOW" : "HIDE"}
                        </Button>
                      </div>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={8}>
                    <Form.Label className="small mb-3">Step Two</Form.Label>
                    <h6 className="mb-3">Scan this code to sign in</h6>
                    <ul className="small text-muted">
                      <li className="mb-3">Open the Password Manager mobile app on a device where you’re not signed in.</li>
                      <li className="mb-3">Select “Sign in.”</li>
                      <li className="mb-3">Select “Scan QR Code.”</li>
                    </ul>
                  </Form.Group>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default SetupAnotherDevice;
